import type { Dispatch } from 'redux'
import type { ApplicationDataDTO, AppSettingsDTO } from 'shared/types/api'
import endpoints from 'shared/store/endpoints'
import { ws } from 'shared/store/ws'
import type { RootState } from 'shared/store/reducers'

type GetState = () => RootState

type ActionApplicationDataResponse = {
    type: 'APPLICATION_DATA_RESPONSE',
    data: ApplicationDataDTO
}

type ActionAppSettingsResponse = {
    type: 'APP_SETTINGS_RESPONSE',
    data: AppSettingsDTO
}

const actionAppSettingsResponse = (
    data: AppSettingsDTO
): ActionAppSettingsResponse => ({
    type: 'APP_SETTINGS_RESPONSE',
    data
})

const fetchApplicationData = () => {
    return (dispatch: Dispatch<any>) => {
        return ws
            .get(endpoints.applicationData)
            .then(response => {
                dispatch({
                    type: 'APPLICATION_DATA_RESPONSE',
                    data: response.data
                })
            })
            .catch(error =>
                console.error('Error fetching application data', error)
            )
    }
}

const fetchApplicationHomePageData = (response: any) => {
    return (dispatch: Dispatch<any>, getState: GetState) => {
        const { authenticated } = getState().userState

        dispatch({
            type: 'APPLICATION_DATA_RESPONSE',
            data: response.applicationData
        })
        dispatch({
            type: 'APP_SETTINGS_RESPONSE',
            data: response.settings
        })
        dispatch({
            type: 'PAGE_DATA_ROOT_RESPONSE',
            data: response.initialize
        })
        dispatch({
            type: 'FEATURES_RECEIVED',
            features: response.features
        })
        dispatch({
            type: 'USER_ANALYTICS_DATA',
            analyticsData: response.analyticsData
        })
        dispatch({
            type: 'ECOMM_FETCH_PRICE_EDGES',
            priceEdges: response.priceEdge
        })
        dispatch({
            type: 'PAGE_DATA_HOMEPAGE_RESPONSE',
            data: response.home
        })
        dispatch({
            type: 'SEARCH_RESULTS',
            restaurants: response?.storeLocator?.results || []
        })

        if (authenticated) {
            const updatedCacOrders =
                response.cacOrders && response.cacOrders?.length > 0
                    ? response.cacOrders.reduce(
                          (acc, order) => ({
                              ...acc,
                              [order.token]: order
                          }),
                          {}
                      )
                    : []

            const updatedDeliveryOrders =
                response.dlvOrders && response.dlvOrders?.length > 0
                    ? response.dlvOrders.reduce(
                          (acc, order) => ({
                              ...acc,
                              [order.token]: order
                          }),
                          {}
                      )
                    : []

            dispatch({
                type: 'ECOMM_UPDATE_ORDERS',
                orders: updatedCacOrders,
                isDelivery: false
            })

            dispatch({
                type: 'ECOMM_UPDATE_ORDERS',
                orders: updatedDeliveryOrders,
                isDelivery: true
            })
        }
    }
}

const fetchAppSettings = () => {
    return async (dispatch: Dispatch<any>) => {
        try {
            const response = await ws.get(endpoints.app.settings)
            if (response && response.data) {
                dispatch(actionAppSettingsResponse(response.data))
            }
        } catch (error) {
            console.error('Error fetching settings', error)
        }
    }
}

export { fetchApplicationData, fetchAppSettings, fetchApplicationHomePageData }

export type Action = ActionApplicationDataResponse | ActionAppSettingsResponse
